import React, { Fragment, useRef } from 'react';
import { GlobalSliderStyles, Navigation, NavigationButton, Slide, Slides, StyledIndicator, Wrapper, getSlideProgress } from './Slider.styles';
import { useSlider } from './use-slider';
import SvgChevron from '../../../../play-core/icons/Chevron';
import { IconWrapper } from '../IconWrapper/IconWrapper';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Slider = ({
  slides,
  renderSlide
}) => {
  const numberOfSlides = slides.length;
  const slidesRef = useRef(null);
  const {
    dragStart,
    dragEnd,
    dragAction,
    wheelSlideDebounced,
    shiftSlide,
    currentIndex,
    progress,
    transitionEnd
  } = useSlider(numberOfSlides, slidesRef);
  const nextSlide = () => shiftSlide(1);
  const prevSlide = () => shiftSlide(-1);
  const enableSlider = numberOfSlides > 1;
  const sliderHandlers = enableSlider ? {
    onTouchStart: dragStart,
    onTouchEnd: dragEnd,
    onTouchCancel: dragEnd,
    onMouseMove: dragAction,
    onWheel: wheelSlideDebounced,
    onTransitionEnd: transitionEnd
  } : {};
  return /*#__PURE__*/_jsxs(Wrapper, {
    children: [/*#__PURE__*/_jsx(GlobalSliderStyles, {}), /*#__PURE__*/_jsx(Slides, {
      ref: slidesRef,
      ...sliderHandlers,
      children: slides.map((item, index) => {
        const handleFocus = () => shiftSlide(index - currentIndex);
        const transitionProgress = getSlideProgress(index, progress, numberOfSlides);
        return /*#__PURE__*/_jsx(Slide, {
          style: {
            opacity: transitionProgress
          },
          index: index,
          currentIndex: currentIndex,
          onFocus: handleFocus,
          children: renderSlide({
            item,
            index,
            transitionProgress,
            sliderProgress: progress,
            numberOfSlides
          })
        }, index);
      })
    }), enableSlider && /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsxs(Navigation, {
        children: [/*#__PURE__*/_jsx(NavigationButton, {
          onClick: prevSlide,
          children: /*#__PURE__*/_jsx(IconWrapper, {
            size: 24,
            icon: /*#__PURE__*/_jsx(SvgChevron, {
              orientation: 'left'
            })
          })
        }), /*#__PURE__*/_jsx(NavigationButton, {
          onClick: nextSlide,
          children: /*#__PURE__*/_jsx(IconWrapper, {
            size: 24,
            icon: /*#__PURE__*/_jsx(SvgChevron, {
              orientation: 'right'
            })
          })
        })]
      }), /*#__PURE__*/_jsx(StyledIndicator, {
        count: numberOfSlides,
        activeIndex: currentIndex,
        slideToIndex: index => {
          shiftSlide(index - currentIndex);
        }
      })]
    })]
  });
};